import * as yup from "yup";

const validation = (errors) => {
  return yup.object().shape({
    email: yup.string().email(errors.EMAIL).required(errors.REQUIRED),
    password: yup.string().required(errors.REQUIRED),
  });
};

export default validation;
